var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.64 2.4H3.359c-1.188 0-2.15.972-2.15 2.16L1.2 21.392c0 .962 1.163 1.445 1.844.764l2.475-2.475h15.12a2.167 2.167 0 0 0 2.161-2.16V4.56a2.167 2.167 0 0 0-2.16-2.161zM8.16 10.98a1.68 1.68 0 1 1-3.36 0 1.68 1.68 0 0 1 3.361.001zm5.52 0a1.68 1.68 0 1 1-3.361-.001 1.68 1.68 0 0 1 3.361.001zm5.52 0a1.68 1.68 0 1 1-3.36-.001 1.68 1.68 0 0 1 3.36.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.744d87fcb2fd1fa33d96b7cc394e8845.svg";
export { ForwardRef as ReactComponent };